import { LockOutlined, MailOutlined } from "@ant-design/icons";
import { Checkbox } from "antd";
import { AppButton, AppInput } from "components/antd-ui";
import { ChangeEvent, FormEvent, useState } from "react";
import { Link } from "react-router-dom";

type LoginFormValues = {
  username: string;
  password: string;
};

type LoginFormProps = {
  loading?: boolean;
  onSubmit?: (values: LoginFormValues) => void | Promise<void>;
};

const LoginForm = ({ loading = false, onSubmit }: LoginFormProps) => {
  const [form, setForm] = useState<LoginFormValues>({
    username: "",
    password: "",
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await onSubmit?.(form);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-5">
        <AppInput
          label="Tên đăng nhập"
          name="username"
          type="text"
          id="username"
          value={form.username}
          placeholder="Nhập tên đăng nhập"
          prefix={<MailOutlined />}
          size="large"
          onChange={handleChange}
        />
      </div>

      <div className="mb-5">
        <AppInput
          label="Mật khẩu"
          inputType="password"
          name="password"
          id="userPassword"
          value={form.password}
          placeholder="••••••••"
          prefix={<LockOutlined />}
          size="large"
          onChange={handleChange}
        />
      </div>

      <AppButton
        htmlType="submit"
        tone="primary"
        size="large"
        loading={loading}
        className="w-full"
      >
        Đăng nhập
      </AppButton>
    </form>
  );
};

export default LoginForm;
